import {
  ChangeDetectionStrategy,
  Component,
  Input,
} from '@angular/core';

import { FdkIconComponent } from '../icon/icon.component';
import { FdkIconName } from '../icon/icon.types';

export type FdkIconButtonVariant = 
  | 'primary'
  | 'secondary'

@Component({
  selector: 'fdk-icon-button',
  imports: [FdkIconComponent],
  templateUrl: './icon-button.component.html',
  styleUrl: './icon-button.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class FdkIconButtonComponent {
  @Input({ required: true }) icon!: FdkIconName;
  @Input({ alias: 'aria-label', required: true }) ariaLabel!: string;
  @Input() variant: FdkIconButtonVariant = 'primary';
}
